import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface CheckIconPropsType {
    className?: string;
    onClick?: (e: React.SyntheticEvent) => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<CheckIconPropsType>`
    height: auto;
`;

export const CheckIcon = observer('CheckIcon', ({ className, onClick }: CheckIconPropsType): React.ReactElement => {
    return (
        <SvgElement
            className={className}
            onClick={onClick}
            width='16'
            height='16'
            fill='#1e293b'
            viewBox='0 0 16 16'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fill='#fill'
                fillRule='evenodd' d='M5.688 13.614c-.185.183-.447.335-.679.335-.231 0-.494-.16-.687-.343L0 9.34l1.374-1.357 3.643 3.597L14.649 2 16 3.38 5.688 13.613Z'
                clipRule='evenodd'
            />
        </SvgElement>
    );
});
